

<div class="font-poppins">
  <div nz-row >
    

      <div style="padding-right: 20px; height: 100%;" nz-col nzSpan="18">
        <nz-spin nzTip="Please wait...." [nzSpinning]="showLoad">
        <nz-card class="m-0 docs-container">
          <div class="m-b-10 m-r-20">
            <button
              
              title="Go Back"
              (click)="goBack()"
              nz-button
              nzType="default"
            >
              <i nz-icon nzType="arrow-left" nzTheme="outline"></i>
            </button>
          </div>
          <div style="height: 91%">

        <!-- <ngx-doc-viewer
          [url]="resourceUrl"
          viewer="google"
          style="width: 100%; height: 50vh"
        ></ngx-doc-viewer> -->
        
            <iframe *ngIf="resourceUrl" [src]="resourceUrl" width="100%" height="100%" style="object-fit: cover;"></iframe>
            <nz-empty *ngIf="!showLoad && !resourceUrl" id="resource_empty" nzNotFoundImage="simple" width="100%" height="100%" style="object-fit: cover;"></nz-empty>                      
          </div>
        </nz-card>
      </nz-spin>
      </div>

      <div style="height: 100%" nz-col nzSpan="6">
        <nz-card
          class="m-0 docs-container"
          [nzBodyStyle]="{ padding: '0px' }"
          
          style="overflow-y: hidden"
        >
          <div style="padding: 24px">
            <div nz-row class="font">
              <div nz-col nzSpan="20">
                <span style="font-weight: 600">Access Groups</span>
              </div>
              <!-- <div nz-col nzSpan="4">
                <a class="add-label">
                  <i
                    class="fa fa-plus button-plus-icon-add-label"
                    aria-hidden="true"
                  ></i
                  >Add
                </a>
              </div> -->
            </div>
            <div nz-row nzGutter="16">
              <div nz-col nzSpan="24">
                <a nz-tooltip>
                  <ng-container *ngFor="let name of records.group_names">
                    <nz-avatar
                      [nzSize]="35"
                      [nzText]="getFirstLetter(name)"
                      style="
                        margin-right: 4px;
                        color: #2d2d35;
                        background-color: #6bbd97;
                      "
                    ></nz-avatar>
                  </ng-container>
                </a>
              </div>
            </div>
            
            <!-- <div nz-row nzGutter="16">
              <div nz-col nzSpan="24">
                <a nz-tooltip>
                  <nz-avatar
                    [nzSize]="35"
                    nzText="A"
                    style="
                      margin-right: 4px;
                      color: #2d2d35;
                      background-color: #6bbd97;
                    "
                  ></nz-avatar>
                  <nz-avatar [nzSize]="35" style="margin-right: 4px"></nz-avatar>
                  <nz-avatar [nzSize]="35" style="margin-right: 4px"></nz-avatar>
                  <nz-avatar [nzSize]="35" style="margin-right: 4px"></nz-avatar>
                  <nz-avatar [nzSize]="35" style="margin-right: 4px"></nz-avatar>
                </a>
              </div>
            </div> -->
          </div>

          <nz-divider style="margin: 0px 0px 0px 0px"></nz-divider>

          <div
            class="right-height"
            style="
              padding: 5px 24px 0px 24px;
              overflow-y: auto;
              overflow-x: hidden;
            "
          >
            <div nz-row class="font" style="padding-bottom: 5px">
              <div nz-col nzSpan="24">
                <span style="font-weight: 600">Resource Status</span>
              </div>
              <div nz-col nzSpan="24">
                <nz-badge
                  *ngIf="records.is_active == 1"
                  nzStatus="success"
                ></nz-badge>
                <nz-badge
                  *ngIf="records.is_active == 0"
                  nzStatus="error"
                ></nz-badge>
                <!-- <nz-badge
                  *ngIf="records.status == 'Not enough data'"
                  nzStatus="processing"
                ></nz-badge> -->
                <!-- <span class="text-capitalize">{{ records.is_ }}</span> -->
                <span class="text-capitalize">{{ records.is_active === 1 ? 'Active' : 'Inactive' }}</span>
              </div>
            </div>

            <!-- <div nz-row class="font" style="padding-bottom: 5px">
              <div nz-col nzSpan="24">
                <span style="font-weight: 600">Popularity</span>
              </div>
              <div nz-col nzSpan="24">
                <nz-badge
                  *ngIf="records.popularity == 'high'"
                  nzStatus="success"
                ></nz-badge>
                <nz-badge
                  *ngIf="records.popularity == 'Medium'"
                  nzStatus="error"
                ></nz-badge>
                <nz-badge
                  *ngIf="records.status == 'Not enough data'"
                  nzStatus="processing"
                ></nz-badge>
                <span class="text-capitalize">{{ records.popularity }}</span>
                <span *ngIf="!records.popularity" class="text-capitalize">
                  <nz-badge nzStatus="success">high</nz-badge></span
                >
              </div>
            </div> -->

            <div nz-row class="font" style="padding-bottom: 5px">
              <div nz-col nzSpan="24">
                <span style="font-weight: 600">Tags</span>
              </div>
              <!-- <div nz-col nzSpan="4">
                <a class="add-label">
                  <i
                    class="fa fa-plus button-plus-icon-add-label"
                    aria-hidden="true"
                  ></i
                  >Add
                </a>
              </div> -->
              <div nz-col>
                <!-- {{records.tag | json }} -->
                <ng-container *ngIf="records.tag && records.tag.length > 0">
                  <ng-container
                    *ngIf="records.tag.length <= 2; else moreTags"
                  >
                    <nz-tag
                      *ngFor="let tag of records.tag.slice(0, 2)"
                      [nzMode]="default"
                      [nzColor]="'#ededed'"
                    >
                      {{ tag.tag_name }}
                    </nz-tag>
                  </ng-container>
                  <ng-template #moreTags>
                    <span *ngFor="let tag of records.tag.slice(0, 2)">
                      <nz-tag [nzMode]="default" [nzColor]="'#ededed'">{{
                        tag.tag_name
                      }}</nz-tag>
                    </span>

                    <span
                      nz-popover
                      [nzPopoverContent]="moreContents"
                      nzPopoverPlacement="bottom"
                      (mouseenter)="updateMoreTagsContent(records.tag)"
                      (mouseleave)="resetMoreTagsContent()"
                    >
                    <span style="cursor: pointer; color: #dd3d3d;">+{{ records.tag.length - 2 }} more</span>
                      <!-- <nz-tag [nzMode]="default" [nzColor]="'#ededed'" class="cursor: pointer"
                        >+{{ records.tag.length - 2 }} more</nz-tag
                      > -->
                    </span>

                    <ng-template #moreContents>
                      <span *ngFor="let tag of moreTagsContent">
                        <nz-tag
                          [nzMode]="default"
                          [nzColor]="'#ededed'"
                          >{{ tag }}</nz-tag
                        >
                      </span>
                    </ng-template>
                  </ng-template>
                </ng-container>
                <!-- <nz-tag
                  *ngFor="let tag of records.tag; let i = index"
                  [nzMode]="default"
                  [nzColor]="'#ededed'"
                >
                  {{ tag.tag_name }}
                </nz-tag> -->
              </div>
            </div>

            <nz-divider style="margin: 10px !important"></nz-divider>

            <div class="">
              <!-- <div nz-row class="font" style="padding-bottom: 5px">
                <div nz-col nzSpan="24">
                  <span style="font-weight: 600">Uploaded By</span>
                </div>
                <div nz-col nzSpan="24">
                  <span class="text-capitalize">Donna Jones</span>
                </div>
              </div> -->

              <div nz-row class="font" style="padding-bottom: 5px">
                <div nz-col nzSpan="24">
                  <span style="font-weight: 600">Uploaded Date</span>
                </div>
                <div nz-col nzSpan="24">
                  <span class="text-capitalize">{{ records.uploaded_date | date:'MM/dd/yyyy, h:mm a' }}</span>
                </div>
              </div>

              <!-- <div nz-row class="font" style="padding-bottom: 5px">
                <div nz-col nzSpan="24">
                  <span style="font-weight: 600">Expires</span>
                </div>
                <div nz-col nzSpan="24">
                  <span class="text-capitalize">{{ records.expires_date | date:'medium' }}</span>
                </div>
              </div> -->
            </div>

            <nz-divider style="margin: 10px !important"></nz-divider>

            <div nz-row class="font" style="padding-bottom: 6.5px">
              <div nz-col nzSpan="24">
                <span style="font-weight: 600">Document Notes</span>
              </div>
              <div nz-col nzSpan="24">
                <p style="color: #2d2d35">
                  {{records.document_notes}}
                  <!-- Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ullam
                  nesciunt in quibusdam sit placeat quae recusandae illum magnam.
                  Unde, eligendi fuga! Laudantium quidem cumque neque corporis
                  impedit, delectus nihil dolores? -->
                </p>
              </div>
            </div>
          </div>
  <!-- 
          <div style="padding: 24px">
            <div nz-row style="margin-bottom: 15px">
              <button
                nz-button
                nzType="default"
                class="btn-outline"
                style="width: 100%"
              >
                Analytics
              </button>
            </div>

            <div nz-row>
              <button
                nz-button
                nzType="default"
                class="btn-outline"
                style="width: 100%"
              >
                Comments
              </button>
            </div>
          </div> -->
        </nz-card>
      </div>
    </div>

</div>
